//For IE Exception.
import "babel-polyfill";

import Vue from 'vue'


import App from './App.vue'
import store from './common/store'
//expose to global.
Vue.store = store;

import router from './common/router'
//expose to global.
Vue.router = router;

import {sync} from 'vuex-router-sync'
sync(store, router)

import VueResource from 'vue-resource'
Vue.use(VueResource)

Vue.http.options.root = store.state.host;


import NProgress from 'vue-nprogress'
Vue.use(NProgress)

import filters from './common/filter'
// register global utility filters.
Object.keys(filters).forEach(key => {
	Vue.filter(key, filters[key])
})


//import partial element. ele.
import {DatePicker, Steps, Step, Tooltip, TimeSelect} from 'element-ui'
Vue.use(DatePicker)
Vue.use(Steps)
Vue.use(Step)
Vue.use(Tooltip)
Vue.use(TimeSelect)

const nprogress = new NProgress({parent: '.nprogress-container'})

/* eslint-disable no-new */
new Vue({
	el: '#app',
	nprogress,
	store,
	router,
	template: "<app/>",
	components: {App}
})



// WEBPACK FOOTER //
// ./src/main.js